import React, { useState, useEffect } from 'react';
import './PatientInsights.css';
import AppProfileModal from './ProjectManager/ProjectDetails/AppProfileModal/AppProfileModal';

function PatientInsights({ userId, onClose }) {
  const [patientData, setPatientData] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    if (userId) {
      setLoading(true);
      fetch(`https://service3.szapfs.org/platformGetPatientInsights?userId=${userId}`)
        .then(response => response.json())
        .then(data => {
          setPatientData(data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Error fetching patient data:', error);
          setLoading(false);
        });
    }
  }, [userId]);
  
  return (
    <div className="PatientSelectionSection">
      <div className="allp" onClick={onClose}>  <div className="allp-text"> ← All Patients  </div></div>
      <div className="PatientSelectionSectionContent">
          <AppProfileModal appUser={patientData} />
        </div>
    </div>
  );
}

export default PatientInsights;
